import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AzureCosmosDbDataset } from 'app/model/dataset/azure-cosmos-db.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureCosmosDbDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            structure: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
                collectionName: '*'
            }
        }
    }
})
export class AzureCosmosDatasetAdapter extends TabularTypeDatasetAdapter<AzureCosmosDbDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AzureCosmosDbDataset): Promise<Model.DatasetResource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetResource;
        const modelDataset = this.properties(modelDatasetResource) as Model.DocumentDbCollectionDataset;
        modelDataset.type = Metamodel.modelFor(AzureCosmosDbDataset).name;
        modelDataset.structure = this.columnValueToResource(dataset, dataset.columns);
        modelDataset.typeProperties = {
            collectionName: ValueAdapter.toResource(dataset, AzureCosmosDbDataset.TABLE_NAME)
        };
        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }
        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AzureCosmosDbDataset): Promise<AzureCosmosDbDataset> {
        if (!dataset) {
            dataset = AzureCosmosDbDataset.MODEL.create<AzureCosmosDbDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        const model = modelDatasetResource.properties as Model.DocumentDbCollectionDataset;
        if (model) {
            if (model.typeProperties) {
                ValueAdapter.toModel(dataset, AzureCosmosDbDataset.TABLE_NAME, model.typeProperties.collectionName);
            }
            dataset.columns = this.columnResourceToValue(dataset, model.structure);
        }

        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, AzureCosmosDbDataset.MODEL));
        return dataset;
    }
}
